import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';

import {
  Navbar,
  Nav,
  NavItem,
} from 'react-bootstrap';

const ThisNavbar = styled(Navbar)`
  background-color: white;
  border-radius: 0;
  margin-bottom: 0;
`;

const HeaderLink = styled(Link)`
`;

const HeaderImage = styled.img`
  display: inline !important;
`;

const HeaderSpan = styled.span`
  display: inline;
  font-weight: 700;
  padding: 0 20px 0 14px;
  position: relative;
  top: 2px;
`;

const ThisNavbarBrand = styled(Navbar.Brand)`
  height: 64px;
  padding: 13px 15px;
`;

const ThisNavItem = styled(NavItem)`
  font-weight: 700;

  a {
    padding: 22px 15px 21px 15px !important
    margin: 0 10px;
  }

  &.active a {
    background-color: white !important;
    border-bottom: 4px solid #00ad83;
    color: #00ad83 !important;
  }
`;

const NavigationUI = ({ location, account }) => (
  <ThisNavbar>
    <Navbar.Header>
      <ThisNavbarBrand>
        <HeaderLink to="/">
          <HeaderImage src="/images/logo.svg" />
          <HeaderSpan>WWWorld Cup</HeaderSpan>
        </HeaderLink>
      </ThisNavbarBrand>
    </Navbar.Header>
    <Nav>
      <LinkContainer to="/new-cards">
        <ThisNavItem active={location.pathname === '/new-cards'}>New Cards</ThisNavItem>
      </LinkContainer>
      <LinkContainer to="/your-cards">
        <ThisNavItem active={location.pathname === '/your-cards'}>Your Cards</ThisNavItem>
      </LinkContainer>
      <ThisNavItem href="https://opensea.io/assets/wwworldcup" target="_blank">Marketplace</ThisNavItem>

      {account && account === "0x2907379bA32dF3b18cDA076792e0E8Bc3BfB2560" &&
        <LinkContainer to="/admin">
          <ThisNavItem active={location.pathname === '/admin'}>Admin</ThisNavItem>
        </LinkContainer>
      }
    </Nav>
  </ThisNavbar>
);

export default NavigationUI;



// WEBPACK FOOTER //
// ./src/components/ui/NavigationUI.js